import { useCallback, useEffect, useState } from 'react';
import api from './useApi';
import useRefreshOnFocus from './useRefreshOnFocus';

// How many of the signed-in person's own bids need attention, for the badge on
// Bid Tracker in the sidebar (the CRM redesign of 29 September 2026). The
// server counts with attentionFor, the rules the morning email uses. Bids move
// slowly, so this polls every five minutes and catches up when the tab is
// returned to or the page changes.
const POLL_INTERVAL = 5 * 60 * 1000;

export default function useBidAttentionCount({ enabled = true } = {}) {
  const [count, setCount] = useState(0);

  const refresh = useCallback(() => {
    if (!enabled) return;
    api.get('crm/bids/attention-count')
      .then(c => setCount(Number(c?.count || 0)))
      // Non-fatal: a failed poll keeps the last known count.
      .catch(() => {});
  }, [enabled]);

  useEffect(() => {
    if (!enabled) { setCount(0); return undefined; }
    refresh();
    const timer = setInterval(refresh, POLL_INTERVAL);
    return () => clearInterval(timer);
  }, [enabled, refresh]);

  useRefreshOnFocus(refresh);

  return { count, refresh };
}
